// src/store/useJourneyStore.ts
import { create } from "zustand";

import type { EstimateResponse, LatLng } from "../types/journey";

type JourneyState = {
  origin: LatLng | null;
  destination: LatLng | null;
  estimate: EstimateResponse | null;
  loading: boolean;
  error: string | null;

  setOrigin: (v: LatLng | null) => void;
  setDestination: (v: LatLng | null) => void;
  setEstimate: (v: EstimateResponse | null) => void;
  setLoading: (v: boolean) => void;
  setError: (v: string | null) => void;
  reset: () => void;
};

export const useJourneyStore = create<JourneyState>(set => ({
  origin: null,
  destination: null,
  estimate: null,
  loading: false,
  error: null,

  setOrigin: origin => set({ origin }),
  setDestination: destination => set({ destination }),
  setEstimate: estimate => set({ estimate }),
  setLoading: loading => set({ loading }),
  setError: error => set({ error }),
  reset: () =>
    set({ origin: null, destination: null, estimate: null, loading: false, error: null }),
}));
